import { useSelector } from 'react-redux';
import RouteSolver from 'src/routes/RouteSolver';
import { userSelectors } from 'src/selectors';
// routes

export default function GuestGuard({ children }) {
  const isAuthenticated = useSelector(userSelectors.isAuth());

  if (isAuthenticated) {
    return <RouteSolver />;
  }

  return <>{children}</>;
}
